import AllowedDocument from "models/documents/allowed-document";
import DocumentSelectorOption from "../document-selector-option/DocumentSelectorOption";

import StyledDocumentSelector from "./styles/StyledDocumentSelector.styled";

interface DocumentSelectorProps {
  allowedDocuments: AllowedDocument[];
  selectedDocument: AllowedDocument;
  onSelect: (documentType: string) => void;
}

const DocumentSelector: React.FC<DocumentSelectorProps> = ({
  allowedDocuments,
  selectedDocument,
  onSelect,
}) => {
  return (
    <StyledDocumentSelector>
      {allowedDocuments.map((doc) => {
        return (
          <DocumentSelectorOption
            key={doc.type}
            isSelected={doc.type === selectedDocument.type}
            onClick={() => onSelect(doc.type)}
            doc={doc}
          />
        );
      })}
    </StyledDocumentSelector>
  );
};

export default DocumentSelector;
